import type { RouteLocationRaw } from "vue-router";

/** Nomes das rotas do módulo, registradas em router/index.ts. */
export const ROTAS_PAINEL_CONSULTOR = {
  /** Link do menu: o guard leva cada perfil para a própria tela. */
  entrada: "painel-consultor",
  diretoria: "painel-consultor-diretoria",
  regional: "painel-consultor-regional",
  consultor: "painel-consultor-consultor"
} as const;

export const rotaDiretoria = (): RouteLocationRaw => ({
  name: ROTAS_PAINEL_CONSULTOR.diretoria
});

export const rotaRegional = (codRegional: number): RouteLocationRaw => ({
  name: ROTAS_PAINEL_CONSULTOR.regional,
  params: { codRegional }
});

export const rotaConsultor = (
  codRegional: number,
  codConsultor: number
): RouteLocationRaw => ({
  name: ROTAS_PAINEL_CONSULTOR.consultor,
  params: { codRegional, codConsultor }
});

/**
 * Telas de outros módulos para onde o painel redireciona: ele só resume os
 * dados, sem repetir formulário nem lógica delas.
 */
const ROTAS_DESTINO = {
  atas: "atas-visita",
  chamados: "tickets-jira",
  performance: "resultados-pos-vendas"
} as const;

/** Atas de Visita em "Nova ata"; a partir de uma loja, já com ela escolhida. */
export const rotaNovaAta = (codConcessionaria?: number): RouteLocationRaw => ({
  name: ROTAS_DESTINO.atas,
  query: codConcessionaria
    ? { aba: "nova", concessionaria: String(codConcessionaria) }
    : { aba: "nova" }
});

/** Atas de Visita na aba da lista. */
export const rotaListaAtas = (): RouteLocationRaw => ({
  name: ROTAS_DESTINO.atas,
  query: { aba: "atas" }
});

/** Tickets Jira com o modal de criação aberto. */
export const rotaNovoChamado = (): RouteLocationRaw => ({
  name: ROTAS_DESTINO.chamados,
  query: { novo: "1" }
});

/** Tickets Jira com o chamado aberto, pela chave do Jira (ex.: ASQ-123). */
export const rotaChamado = (codChamado: string): RouteLocationRaw => ({
  name: ROTAS_DESTINO.chamados,
  query: { key: codChamado }
});

export const rotaPerformance = (): RouteLocationRaw => ({
  name: ROTAS_DESTINO.performance
});
